export type BudgetStatus = "over" | "near" | "safe";

export const getUsage = (spent: number, amount: number) => (amount > 0 ? (spent / amount) * 100 : 0);

export const getBudgetStatus = (spent: number, amount: number): BudgetStatus => {
  const usage = getUsage(spent, amount);
  if (spent <= 0 || usage <= 0) return "safe";
  if (spent > amount) return "over";
  if (usage >= 80) return "near";
  return "safe";
};
